'use client';

import axios from 'axios';
import { useState, useEffect } from 'react';
import { Box, Stack, Flex, StackSeparator, Text } from "@chakra-ui/react";
import ContentBox from "@/components/partials/ContentBox";
import { LuTrendingUp, LuTrendingDown } from "react-icons/lu";

export default function CoinCotation() {
  const [coinList, setCoinList] = useState([]);

  useEffect(() => {
    axios.get(`${process.env.NEXT_PUBLIC_API_URL}/portal/componentes/widget?name=cotation`).then(response => {
      if(response && response.data && response.data.data) {
      setCoinList(response.data.data);
      }
    });
  }, []);

  return (
    <ContentBox text="Cotação A1" padding="0" smallText={true}>
      <Stack gap="2" separator={<StackSeparator />}>
        { coinList.length > 0 ? coinList.map(coin => (
          <Flex key={coin.coin} w="100%" justifyContent="space-between" >
            <Flex alignItems="center" w="22px" mr="2" >
              { coin.change >= 0 ? (
                <Box color="green.500">
                  <LuTrendingUp size="20px" />
                </Box>
              ) : (
                <Box color="red.500">
                  <LuTrendingDown size="20px" />
                </Box>
              )}
            </Flex>

            <Box flex="1">
                <Text fontWeight="700" mr="2">{ coin.coin }</Text>
                <Text fontWeight="300" textTransform="uppercase" fontSize="0.7em">{ coin.name }</Text>
            </Box>

            <Box textAlign="right">
              <Text fontWeight="400" fontSize="1.1em">R${ coin.change >= 0 ? coin.high : coin.low }</Text>
              <Text fontWeight="300" textTransform="uppercase" fontSize="0.7em">{ coin.change }%</Text>
            </Box>
          </Flex>
        )) : (
          <Text textAlign="center" py="4">Carregando...</Text>
        )}
      </Stack>
    </ContentBox>
  )
}
